import { ContactTypes } from '../config/constants';

const yup = require('yup');

export default function Contact(data) {
  this.id = data && data.id ? data.id : 0;
  this.type = data && data.type ? data.type : ContactTypes.Other;
  this.name = data && data.name ? data.name : '';
  this.focus = data && data.focus ? data.focus : '';
  this.location = data && data.location ? data.location : '';
  this.email = data && data.email ? data.email : '';
  this.phoneNumber = data && data.phoneNumber ? data.phoneNumber : '';
  this.notes = data && data.notes ? data.notes : '';
}

export const contactToApiMap = [
  ['id', 'id'],
  ['type', 'type'],
  ['name', 'name'],
  ['focus', 'focus'],
  ['location', 'location'],
  ['email', 'email'],
  ['phoneNumber', 'phoneNumber'],
  ['notes', 'notes'],
];

export const validationSchema = yup.object().shape({
  id: yup
    .number()
    .integer()
    .positive()
    .required(),
  type: yup.string().required(),
  name: yup.string().required('A name is required'),
  focus: yup.string(),
  location: yup.string(),
  email: yup.string().email(),
  phoneNumber: yup.string(),
  notes: yup.string(),
});



// WEBPACK FOOTER //
// ./src/models/Contact.js